import React from 'react';

import { addIsLoseOnTeams } from '../../../utils/match-status';
import { makeClassNames } from '../../../utils/styles';
import { IMatchData } from '../../molecules/match-data/match-data';
import MatchLight, { IMatchLight } from '../../molecules/match-light/match-light';

import './hero-lmp-slim.scss';

export interface IHeroLmpSlim extends IMatchData, IMatchLight {}

const classNames = () =>
  makeClassNames({
    HeroLmpSlim: 'hero-lmp-slim',
    HeroLmpSlimStatus: 'hero-lmp-slim--status',
    HeroLmpSlimVenue: 'hero-lmp-slim--venue',
  });

const HeroLmpSlim = ({
  match,
  /* istanbul ignore next: default value */ colorSchema = 'dark',
  /* istanbul ignore next: default value */ logoSize = '40',
  /* istanbul ignore next: default value */ fontSize = '16',
  /* istanbul ignore next: default value */ isSlim = true,
  ampProps,
}: IHeroLmpSlim) => {
  const cn = classNames();
  const matchWithLoseTeam = addIsLoseOnTeams(match);

  return (
    <div className={cn.HeroLmpSlim}>
      <MatchLight
        match={matchWithLoseTeam}
        ampProps={ampProps}
        colorSchema={colorSchema}
        logoSize={logoSize}
        fontSize={fontSize}
      />
    </div>
  );
};

export default HeroLmpSlim;
